var _path, _g, _g2, _path2, _path3, _g3, _path4, _path5, _g4, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitePeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 344,
    viewBox: "0 0 643 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378.56 42.374C410.587 59.0276 444.973 74.6553 462.931 105.939C481.291 137.923 482.813 176.644 476.459 212.917C470.215 248.567 456.12 284.483 427.723 306.936C400.782 328.238 363.563 323.883 329.57 329.059C296.046 334.163 262.878 347.503 230.627 336.945C195.501 325.446 165.942 300.435 146.395 269.094C125.731 235.961 106.966 195.229 119.147 158.199C131.059 121.986 178.27 114.271 205.951 88.0476C232.242 63.14 241.541 18.3188 276.59 9.04455C311.991 -0.322829 346.035 25.4619 378.56 42.374Z",
    fill: "url(#paint0_linear_2606_25330)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.661 99.6752C398.074 104.95 394.944 110.372 389.669 111.785L322.814 129.699C317.54 131.112 312.118 127.981 310.704 122.707L299.188 79.7289C297.775 74.4546 300.906 69.0324 306.18 67.6191L373.035 49.7054C378.309 48.2921 383.732 51.4226 385.145 56.697L396.661 99.6752Z",
    fill: "#B06A8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.246 92.7049L313.472 126.954C313.426 127.039 313.424 127.129 313.387 127.21C314.564 128.354 315.998 129.18 317.577 129.629C317.632 129.556 317.706 129.51 317.754 129.428L337.529 95.1758C338.21 93.9927 337.806 92.4837 336.625 91.7996C335.439 91.1168 333.93 91.5212 333.246 92.7049ZM396.588 104.916C396.52 104.863 396.469 104.787 396.387 104.74L362.14 84.963C360.953 84.2802 359.444 84.6845 358.761 85.8682C358.078 87.052 358.482 88.561 359.666 89.2444L393.916 109.021C393.995 109.066 394.088 109.069 394.169 109.106C395.315 107.929 396.141 106.495 396.588 104.916Z",
    fill: "#87506B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.035 49.7054L306.18 67.6191C300.906 69.0324 297.775 74.4546 299.188 79.7289L299.847 82.1882L343.81 107.505C349.543 110.813 356.931 108.834 360.247 103.101L385.79 59.1062L385.145 56.697C383.732 51.4226 378.309 48.2921 373.035 49.7054Z",
    fill: "#87506B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.035 49.7069L306.18 67.6207C302.388 68.6366 299.736 71.7374 299.052 75.3526L343.756 101.165C348.485 103.895 354.535 102.274 357.263 97.5453L383.074 52.8389C380.674 50.0503 376.829 48.6903 373.035 49.7069Z",
    fill: "#B06A8C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.912 311.971C307.982 317.352 302.865 320.96 297.484 320.029L229.283 308.236C223.903 307.305 220.295 302.188 221.225 296.808L228.807 252.964C229.737 247.584 234.854 243.975 240.235 244.906L308.436 256.7C313.816 257.63 317.424 262.747 316.494 268.128L308.912 311.971Z",
    fill: "#916AB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.276 279.034L221.955 301.824C221.878 301.881 221.839 301.962 221.771 302.021C222.359 303.552 223.314 304.904 224.559 305.975C224.639 305.931 224.726 305.921 224.803 305.866L257.127 283.074C258.242 282.286 258.508 280.746 257.723 279.63C256.933 278.512 255.393 278.246 254.276 279.034ZM306.647 316.698C306.608 316.621 306.593 316.531 306.539 316.454L283.751 284.131C282.961 283.013 281.422 282.747 280.305 283.535C279.187 284.322 278.921 285.862 279.709 286.979L302.499 319.302C302.551 319.376 302.635 319.418 302.693 319.486C304.227 318.899 305.579 317.943 306.647 316.698Z",
    fill: "#755087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.436 256.7L240.235 244.906C234.854 243.975 229.737 247.584 228.807 252.964L228.373 255.473L257.654 296.901C261.47 302.31 269.006 303.613 274.422 299.801L316.069 270.585L316.494 268.128C317.424 262.747 313.816 257.63 308.436 256.7Z",
    fill: "#755087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.435 256.701L240.234 244.907C236.366 244.238 232.658 245.94 230.519 248.934L260.266 291.123C263.412 295.585 269.584 296.653 274.045 293.505L316.233 263.757C315.225 260.218 312.305 257.37 308.435 256.701Z",
    fill: "#916AB0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.587 55.691C236.643 55.691 283 100.852 283 154.068C283 198.483 226.711 217.658 176.587 217.658C137.549 217.658 107 188.659 107 154.068C107 108.727 125.417 55.691 176.587 55.691Z",
    fill: "url(#paint1_linear_2606_25330)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2606_25330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 107,
    y: -25,
    width: 176,
    height: 243
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.587 -25C236.643 -25 283 100.852 283 154.068C283 198.483 226.711 217.658 176.587 217.658C137.549 217.658 107 188.659 107 154.068C107 108.727 125.417 -25 176.587 -25Z",
    fill: "url(#paint2_linear_2606_25330)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2606_25330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.742 78.1537C145.859 107.693 141.335 118.494 138.89 122.325C138.27 123.274 138.872 124.551 139.985 124.697L189.958 131.247L192.987 29.4028C192.987 29.4028 154.052 23.5096 148.742 78.1537Z",
    fill: "#441D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.817 122.325C246.354 118.494 241.829 107.692 238.964 78.1536C233.655 23.5095 193.625 29.3662 193.625 29.3662L197.767 131.229L247.74 124.679C248.871 124.533 249.455 123.274 248.835 122.307L248.817 122.325Z",
    fill: "#441D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.622 131.389L170.48 157.784L219.08 156.387L215.821 131.389H173.622Z",
    fill: "#FFC7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.805 146.611C171.805 146.611 204.508 149.614 216.029 135.276V118.797L174.575 122.777L171.805 146.611V146.611Z",
    fill: "#F2B594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.325 82.9047C236.888 78.2635 233.116 77.5691 231.275 77.5143C229.471 53.2119 212.397 29.3846 192.989 29.3846C173.582 29.3846 158.713 53.2119 156.908 77.5143C155.323 77.496 150.913 77.8798 150.439 82.923C149.856 89.0808 151.915 93.8133 155.742 95.8599C155.742 95.8599 156.562 96.2619 158.439 96.5908V96.4629C163.177 115.941 177.354 130.066 194.101 130.066C210.848 130.066 225.007 115.96 229.763 96.4994C231.33 96.1888 232.041 95.8599 232.041 95.8599C235.868 93.8133 237.927 89.0808 237.344 82.923L237.325 82.9047Z",
    fill: "#FFC7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.369 65.7008L156.542 65.5914C158.332 35.2182 186.701 30.8974 186.993 30.861L187.249 32.6659C187.249 32.6659 180.344 33.6868 173.402 38.2628C164.141 44.3703 159.1 53.5953 158.369 65.7008V65.7008Z",
    fill: "#30132B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.744 29.3846V45.2137C193.744 45.2137 220.47 41.2519 231.377 77.5109C231.377 77.5109 238.788 28.7274 193.744 29.4029V29.3846Z",
    fill: "#441D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.858 29.3911V45.1964C192.858 45.1964 167.636 41.8968 156.689 78.1014C156.689 78.1014 147.651 28.7349 192.858 29.3911V29.3911Z",
    fill: "#441D39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.206 185.578C270.449 180.271 235.442 162.674 223.152 156.39C223.152 156.32 223.152 156.25 223.106 156.18L220.406 147.499C220.033 146.288 218.916 145.45 217.636 145.45H170.968C169.571 145.45 168.384 146.428 168.128 147.801L164.73 156.064C164.637 156.506 164.66 156.925 164.753 157.321C151.16 164.234 118.528 180.527 103.468 185.601C84.1959 192.095 84.1959 225.007 84.1959 225.007H305.502C305.502 225.007 305.502 192.095 286.23 185.601L286.206 185.578Z",
    fill: "#4598C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28 103.493C156.693 103.493 156.429 103.493 156.328 102.516H156.287C156.287 102.516 156.287 102.299 156.287 102.046C156.247 101.213 156.247 99.9284 156.247 97.8835C156.247 95.8386 156.247 94.5538 156.287 93.7214C156.287 93.468 156.287 93.3052 156.287 93.2509H156.328C156.45 92.2737 156.693 92.2737 157.28 92.2737C157.868 92.2737 158.131 92.2737 158.233 93.2509H158.273C158.273 93.2509 158.273 93.468 158.273 93.7214C158.314 94.5538 158.314 95.8386 158.314 97.8835C158.314 99.9284 158.314 101.213 158.273 102.046C158.273 102.299 158.273 102.462 158.273 102.516H158.233C158.111 103.493 157.868 103.493 157.28 103.493Z",
    fill: "#FFA33A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.127 103.493C231.623 103.493 231.398 103.493 231.311 102.516H231.276C231.276 102.516 231.276 102.299 231.276 102.046C231.241 101.213 231.241 99.9284 231.241 97.8835C231.241 95.8386 231.241 94.5538 231.276 93.7214C231.276 93.468 231.276 93.3052 231.276 93.2509H231.311C231.415 92.2737 231.623 92.2737 232.127 92.2737C232.631 92.2737 232.856 92.2737 232.943 93.2509H232.978C232.978 93.2509 232.978 93.468 232.978 93.7214C233.013 94.5538 233.013 95.8386 233.013 97.8835C233.013 99.9284 233.013 101.213 232.978 102.046C232.978 102.299 232.978 102.462 232.978 102.516H232.943C232.839 103.493 232.631 103.493 232.127 103.493Z",
    fill: "#FFA33A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.135 163.071C174.135 163.071 173.995 163.071 173.949 163.071C173.32 162.955 172.878 162.373 172.994 161.721L174.763 151.386C174.88 150.758 175.485 150.339 176.113 150.432C176.742 150.549 177.184 151.13 177.068 151.782L175.299 162.117C175.206 162.675 174.717 163.094 174.158 163.094L174.135 163.071Z",
    fill: "#2579AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.563 163.067C213.005 163.067 212.516 162.671 212.423 162.089L210.654 151.755C210.538 151.127 210.98 150.521 211.608 150.405C212.237 150.312 212.842 150.731 212.958 151.359L214.727 161.694C214.844 162.322 214.401 162.927 213.773 163.044C213.703 163.044 213.633 163.044 213.587 163.044L213.563 163.067Z",
    fill: "#2579AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.872 164.049C194.22 164.049 193.708 163.536 193.708 162.885V152.411C193.708 151.759 194.22 151.247 194.872 151.247C195.524 151.247 196.036 151.759 196.036 152.411V162.885C196.036 163.536 195.524 164.049 194.872 164.049Z",
    fill: "#2579AD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.469 325.253C481.392 336.99 513.313 276.949 525.052 223.015C531.633 192.783 489.58 185.343 459.355 178.764C407.576 167.493 334.934 127.389 323.661 179.179C308.775 247.569 359.094 310.37 427.469 325.253Z",
    fill: "url(#paint3_linear_2606_25330)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2606_25330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 321,
    y: 88,
    width: 205,
    height: 239
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.547 325.332C481.47 337.069 513.391 277.028 525.13 223.093C531.71 192.862 493.853 96.6143 463.628 90.0354C411.849 78.765 335.012 127.468 323.739 179.258C308.853 247.648 359.172 310.449 427.547 325.332Z",
    fill: "url(#paint4_linear_2606_25330)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2606_25330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.079 291.165C373.101 285.092 418.134 261.781 418.134 261.781H462.905C462.905 261.781 507.916 285.092 525.959 291.165C543.981 297.237 543.981 328.014 543.981 328.014H337.036C337.036 328.014 337.036 297.237 355.057 291.165H355.079Z",
    fill: "#424777"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M463.296 265.175L460.357 240.493H420.897L417.85 263.869L422.031 263.989L432.434 271.053L437.44 320.33L445.711 271.662L453.665 264.898L463.296 265.175Z",
    fill: "#C1735C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.057 254.727C462.057 254.727 431.476 257.535 420.702 244.127V228.717L459.467 232.439L462.057 254.727V254.727Z",
    fill: "#A5503C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.383 257.472L477.118 268.986L457.246 288.378L445.711 271.663L462.383 257.472Z",
    fill: "#515882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.433 271.053L418.656 257.667L405.226 268.289L423.009 287.747L432.433 271.053Z",
    fill: "#515882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.546 140.017C445.397 132.965 458.848 128.656 458.848 128.656C455.518 150.704 442.851 145.959 442.851 145.959C442.589 145.437 442.415 144.915 442.263 144.414C432.338 149.942 424.067 129.657 424.067 129.657C437.888 130.658 441.675 136.056 442.546 140.017V140.017Z",
    fill: "#FF7C59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.364 241.928C425.335 241.928 412.613 229.3 408.337 211.891C406.931 211.613 406.311 211.31 406.311 211.31C402.874 209.477 401.025 205.239 401.549 199.724C401.942 195.585 405.303 194.949 406.955 194.889C408.582 173.132 422.918 156.116 440.364 156.116C457.808 156.116 472.144 173.13 473.772 194.885C475.203 194.864 479.144 195.221 479.572 199.724C480.095 205.239 478.246 209.477 474.81 211.31C474.81 211.31 474.073 211.67 472.388 211.964L472.392 211.882C468.118 229.296 455.395 241.928 440.364 241.928Z",
    fill: "#C1735C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.26 153.362C476.219 152.85 473.784 195.294 473.784 195.294L440.26 197.77L406.735 195.294C406.735 195.294 404.3 152.85 440.26 153.362V153.362Z",
    fill: "#C1735C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.178 169.436C418.178 169.436 408.306 187.172 406.579 195.026C406.579 195.026 401.236 171.384 413.828 158.597L418.178 169.42V169.436Z",
    fill: "#FF7C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.006 195.025L470.326 181.552H474.817L474.006 195.025Z",
    fill: "#FF7C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.487 151.332C419.487 151.332 419.487 151.25 419.487 151.217C419.487 147.41 422.584 144.338 426.385 144.338C427.22 144.338 427.991 144.501 428.728 144.779C430.759 142.638 433.938 141.249 437.542 141.249C440.868 141.249 443.85 142.442 445.898 144.321C448.045 143.03 450.699 142.246 453.566 142.246C454.779 142.246 455.942 142.393 457.056 142.638C458.678 141.233 460.775 140.383 463.085 140.383C466.723 140.383 469.852 142.491 471.343 145.547C472.244 144.795 473.391 144.338 474.652 144.338C477.536 144.338 479.863 146.674 479.863 149.534C479.863 149.845 479.83 150.139 479.764 150.433C485.45 150.515 490.037 155.139 490.037 160.826C490.037 164.275 488.35 167.33 485.744 169.226C486.711 170.795 487.268 172.642 487.268 174.635C487.268 180.388 482.599 185.045 476.832 185.045C471.064 185.045 466.395 180.388 466.395 174.635C466.395 174.521 466.395 174.406 466.411 174.292C465.019 174.978 463.462 175.371 461.807 175.371C456.286 175.371 451.78 171.089 451.403 165.696C449.519 167.608 446.898 168.785 443.998 168.785C439.689 168.785 435.986 166.17 434.397 162.444C433.528 167.33 429.268 171.04 424.124 171.04C418.357 171.04 413.687 166.383 413.687 160.63C413.687 156.561 416.03 153.048 419.454 151.332H419.487Z",
    fill: "#441D39"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2966 103.853C57.4407 89.156 91.3819 79.2874 106.222 100.636C111.167 107.751 116.968 120.571 117.626 128.61C119.671 134.546 126.708 137.7 129.947 140.284C135.113 144.405 139.987 143.934 133.768 145.781C129.997 146.9 116.05 146.355 113.744 151.547C110.416 159.036 105.073 165.726 97.8759 170.729C76.7318 185.427 34.753 174.813 19.9132 153.464C5.07332 132.115 15.1525 118.551 36.2966 103.853Z",
    fill: "#D37294"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M568.183 179.284C544.499 169.175 509.263 166.388 499.056 190.301C495.655 198.27 492.572 211.999 493.556 220.005C492.756 226.232 486.504 230.747 483.856 233.933C479.632 239.015 474.763 239.542 481.228 240.09C485.147 240.422 498.695 237.063 502.005 241.679C506.781 248.34 513.368 253.808 521.43 257.249C545.114 267.358 584.071 248.458 594.278 224.546C604.484 200.633 591.866 189.392 568.183 179.284Z",
    fill: "#C3DAE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2606_25330",
    x1: 143.389,
    y1: 108.7,
    x2: 459.2,
    y2: 267.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA1BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADCAC8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2606_25330",
    x1: 58.1761,
    y1: 6.61804,
    x2: 258.148,
    y2: 268.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#701D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2606_25330",
    x1: 58.1761,
    y1: 6.61804,
    x2: 258.148,
    y2: 268.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#701D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99393"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2606_25330",
    x1: 359.115,
    y1: 168.374,
    x2: 495,
    y2: 316.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#7750A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934471,
    stopColor: "#FDC1C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2606_25330",
    x1: 359.193,
    y1: 168.453,
    x2: 495.078,
    y2: 316.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#7750A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934471,
    stopColor: "#FDC1C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitePeople);
export default __webpack_public_path__ + "static/media/invite-people.2a8cd36c9e881dee7f0712195dd6723b.svg";
export { ForwardRef as ReactComponent };